import domtoimage from 'dom-to-image';
import { saveAs } from 'file-saver';
import { effectiveBackgroundColor } from 'utils/exportImage';
import { Button, Flex } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faFileImage } from '@fortawesome/pro-light-svg-icons';
import * as ExcelJS from 'exceljs';
import { sortBy } from 'lodash';
import { useTranslation } from 'react-i18next';

const generateImage = () => {
    const node = document.querySelector('.Indicators.w-100 .ant-layout-content') as HTMLElement
        || document.querySelector('.Indicators .ant-layout-content') as HTMLElement;
    if (!node) return;
    domtoimage.toBlob(node, {
        bgcolor: effectiveBackgroundColor(node),
        quality: 1,
        filter: (n: any) => {
            if (!n.className || !n.className.match) return true;
            return !n.className.match('ActionsWrapper') && !n.className.match('ant-btn');
        }
    }).then((blob) => {
        saveAs(blob, `Gerositus-Indicators-${new Date().toLocaleDateString().replace(/\//g, '-')}.png`);
    });
};

const generateExcel = async (indicators: any[], indicatorCategories: any[]) => {
    const sorted = sortBy(indicators, ['reference', 'name']);

    const workbook = new ExcelJS.Workbook();
    workbook.created = new Date();

    const sheet = workbook.addWorksheet('Indicators');
    sheet.columns = [
        { header: 'Name', key: 'name', width: 50 },
        { header: 'Reference', key: 'reference', width: 16 },
        { header: 'Description', key: 'description', width: 80 },
        { header: 'Category', key: 'category', width: 32 },
        { header: 'Frequency', key: 'frequency', width: 18 },
        { header: 'Weight', key: 'weight', width: 12 },
        { header: 'Trend', key: 'trend', width: 12 },
    ];

    sheet.addRows(sorted.map((i) => [
        i.name,
        i.reference,
        i.description,
        i.indicatorCategoryId
            ? (indicatorCategories.find((c: any) => c.id === i.indicatorCategoryId)?.name || '')
            : '',
        i.frequency,
        i.weight,
        i.trend,
    ]));
    sheet.autoFilter = { from: 'A1', to: 'G1' };

    sheet.getRow(1).eachCell((cell) => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDDDDDD' } };
        cell.font = { bold: true, size: 16 };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Gerositus-Indicators.xlsx');
};

export const ExportTab = ({ indicators, indicatorCategories }: { indicators: any[]; indicatorCategories: any[] }) => {
    const { t } = useTranslation();

    return (
        <Flex vertical className="mt-05">
            <Button className="mb-1" variant="outlined" onClick={() => generateExcel(indicators, indicatorCategories)}>
                <FontAwesomeIcon icon={faFileExcel} />
                {t('actions.export.excel')}
            </Button>
            <Button onClick={() => generateImage()}>
                <FontAwesomeIcon icon={faFileImage} />
                {t('actions.export.image')}
            </Button>
        </Flex>
    );
};
